/* Customima · «¿Para quién es?»: recomendador en tres preguntas (persona → recuerdo → joya). Sin dependencias. */
(function () {
  if (window.__cmhRec) return;
  window.__cmhRec = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  window.dataLayer = window.dataLayer || [];
  function track(event, params) { var o = { event: event }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  /* Las etiquetas del catálogo no son uniformes: se clasifica por nombre y tipo de producto */
  function tipoOf(p) {
    var t = norm(p.title), y = norm(p.product_type);
    if (/^(pack|set|reloj|punto de libro|marcapaginas|llavero|estuche)/.test(t)) return '';
    if (/^(collar|colgante|gargantilla|cadena)/.test(t)) return 'collar';
    if (/^pulsera/.test(t)) return 'pulsera';
    if (/^(anillo|alianza|sello)/.test(t)) return 'anillo';
    if (/^medalla/.test(t)) return 'medalla';
    if (/^pendiente/.test(t)) return 'pendientes';
    if (/^aguja/.test(t)) return 'aguja';
    if (/collar|colgante/.test(y)) return 'collar';
    if (/pulsera/.test(y)) return 'pulsera';
    if (/anillo/.test(y)) return 'anillo';
    if (/medalla/.test(y)) return 'medalla';
    return '';
  }
  function grabadoOf(p) {
    var s = norm(p.title + ' ' + p.product_type + ' ' + (p.tags || []).join(' ')), g = {};
    if (/foto/.test(s)) g.foto = 1;
    if (/huell/.test(s)) g.huella = 1;
    if (/patit|mama pata|abuela pata|coleccion:patitos/.test(s)) g.familia = 1;
    if (/fecha|coordenad/.test(s)) g.fecha = 1;
    if (!g.foto && /nombre|inicial|grabad|personaliza/.test(s)) g.nombre = 1;
    return g;
  }

  var cache = {}, bundlePrices = {};
  function load(handle) {
    if (!handle) return Promise.resolve([]);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        /* Solo joyas personalizables: etiqueta «Personalizable» o personalizador Zakeke, y nunca «No personalizable» */
        return (j.products || []).filter(function (p) {
          var t = p.tags || [];
          return (t.indexOf('Personalizable') > -1 || t.indexOf('zakeke-product') > -1) && t.indexOf('No personalizable') < 0 && (p.variants || []).some(function (v) { return v.available !== false; });
        }).map(function (p) {
          var prices = (p.variants || []).filter(function (v) { return v.available !== false; }).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
          var min = prices.length ? Math.min.apply(null, prices) : 0;
          return {
            title: p.title, handle: p.handle, img: p.images && p.images[0] ? p.images[0].src : '',
            price: Object.prototype.hasOwnProperty.call(bundlePrices, p.id) ? bundlePrices[p.id] : min, varies: Object.prototype.hasOwnProperty.call(bundlePrices, p.id) || prices.some(function (n) { return n !== min; }),
            tipo: tipoOf(p), grabado: grabadoOf(p)
          };
        });
      })
      .catch(function () { return []; });
    return cache[handle];
  }

  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  function sized(src, w) { return !src ? '' : /[?&]width=/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function price(it) { return it.price == null ? 'Ver opciones' : (it.bundle || it.varies ? 'Desde ' : '') + fmt.format(it.price); }

  function card(it, rec, root, pos) {
    var a = document.createElement('a');
    a.className = rec ? 'cmh-rec__card is-rec' : 'cmh-rec__card';
    a.href = '/products/' + it.handle;
    a.setAttribute('data-cmh-track', 'recommender_result_click'); a.setAttribute('data-cmh-label', it.handle); a.setAttribute('data-cmh-pos', String(pos));
    if (rec && root.dataset.badge) { var bd = document.createElement('span'); bd.className = 'cmh-rec__badge'; bd.textContent = root.dataset.badge; a.appendChild(bd); }
    var img = document.createElement('img'); img.src = sized(it.img, 600); img.alt = ''; img.width = 400; img.height = 400;
    var tx = document.createElement('span'), b = document.createElement('b'), em = document.createElement('em');
    b.textContent = it.title; em.textContent = price(it);
    tx.appendChild(b); tx.appendChild(em);
    if (rec) { var u = document.createElement('span'); u.className = 'cmh-btn cmh-btn--primary'; u.textContent = root.dataset.cta; tx.appendChild(u); }
    a.appendChild(img); a.appendChild(tx);
    return a;
  }

  function init(root) {
    var picks = {};
    try { picks = JSON.parse(($('[data-cmh-picks]', root) || {}).textContent || '{}'); } catch (e) {}
    var recs = {};
    try { recs = JSON.parse(($('[data-cmh-recs]', root) || {}).textContent || '{}'); } catch (e) {}
    Object.keys(picks).forEach(function (key) { picks[key].forEach(function (it) { if (it.bundle) bundlePrices[it.id] = it.price; }); });
    Object.keys(recs).forEach(function (key) { Object.keys(recs[key]).forEach(function (g) { var it = recs[key][g]; if (it.bundle) bundlePrices[it.id] = it.price; }); });
    var people = $$('[data-cmh-person]', root), gs = $$('[data-cmh-grabado]', root), ts = $$('[data-cmh-tipo]', root);
    var st = { step: 1, person: null, grabado: null, tipo: null, items: [], extra: [], extraP: Promise.resolve(), textra: [], textraP: Promise.resolve(), gName: '', tName: '' };

    /* Solo joyas: fuera cuadros, relojes, llaveros, packs… */
    function match(it, g, t) { return !!it.tipo && (!g || it.grabado[g]) && (!t || it.tipo === t); }

    function go(n) {
      st.step = n;
      $$('[data-step]', root).forEach(function (s) {
        var on = +s.dataset.step === n;
        s.hidden = !on; s.classList.toggle('is-on', on);
      });
      $$('[data-axis]', root).forEach(function (li) {
        var k = +li.dataset.axis, btn = $('button', li);
        li.classList.toggle('is-on', k === n);
        li.classList.toggle('is-done', k < n);
        btn.disabled = k > n;
      });
      var lbl = function (k, v) { var el = $('[data-axis="' + k + '"] [data-axis-label]', root); if (el) { if (!el.dataset.def) el.dataset.def = el.textContent; el.textContent = v || el.dataset.def; } };
      lbl(1, st.person && st.step > 1 ? st.person.dataset.name : '');
      lbl(2, st.step > 2 ? st.gName : '');
      lbl(3, st.step > 3 ? st.tName : '');
      if (n > 1) { var top = root.getBoundingClientRect().top; if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    /* Joyas de la persona + respaldo del recuerdo + respaldo del tipo de joya (en ese orden de preferencia) */
    function list() {
      var m = {}, out = [];
      st.items.concat(st.extra, st.textra).forEach(function (it) {
        if (m[it.handle]) { for (var k in it.grabado) m[it.handle].grabado[k] = 1; return; }
        var c = Object.assign({}, it, { grabado: Object.assign({}, it.grabado) });
        m[it.handle] = c; out.push(c);
      });
      return out;
    }

    /* Se ofrecen los recuerdos y joyas que tiene la persona o que tienen colección de respaldo, salvo los que la persona oculta */
    function availability() {
      var has = st.items.length > 0, all = list();
      var hide = st.person ? (st.person.dataset.hide || '').split(',').map(function (x) { return x.trim(); }) : [];
      gs.forEach(function (b) {
        var k = b.dataset.cmhGrabado;
        b.hidden = hide.indexOf(k) > -1 || (has && !b.dataset.col && !st.items.some(function (it) { return match(it, k, null); }));
      });
      ts.forEach(function (b) { b.hidden = !b.dataset.col && all.length > 0 && !all.some(function (it) { return match(it, st.grabado, b.dataset.cmhTipo); }); });
    }

    function result() {
      var p = st.person, pool = [], seen = {}, items = list();
      function add(list) { list.forEach(function (it) { if (!seen[it.handle]) { seen[it.handle] = 1; pool.push(it); } }); }
      var fav = (picks[p.dataset.cmhPerson] || []).map(function (x) { return x.handle; });
      /* Candidatas por orden: fijadas a mano que encajan, resto de la colección que encaja y, si faltan, las más cercanas */
      add(items.filter(function (it) { return fav.indexOf(it.handle) > -1 && match(it, st.grabado, st.tipo); }));
      add(items.filter(function (it) { return match(it, st.grabado, st.tipo); }));
      if (pool.length < 3) add(items.filter(function (it) { return match(it, null, st.tipo) && it.tipo; }));
      if (pool.length < 3) add(items.filter(function (it) { return match(it, st.grabado, null) && it.tipo; }));
      if (pool.length < 3) add((picks[p.dataset.cmhPerson] || []).filter(function (x) { return x.pers && x.available !== false; }));
      /* Joya fijada para esta persona y este recuerdo: si encaja con el tipo elegido, es la recomendada */
      var cur = st.grabado && (recs[p.dataset.cmhPerson] || {})[st.grabado];
      if (cur && cur.available === false) cur = null;
      if (cur) {
        cur = Object.assign({}, cur, { tipo: tipoOf(cur), grabado: {} }); cur.grabado[st.grabado] = 1;
        if (st.tipo && cur.tipo !== st.tipo) cur = null;
      }
      if (cur) pool = [cur].concat(pool.filter(function (it) { return it.handle !== cur.handle; }));
      /* Si no: la de precio más cercano al objetivo entre las 12 primeras; a los lados, una más económica y otra más especial */
      var target = parseFloat(root.dataset.target) || 100, top = pool.slice(0, 12), rec = cur || top[0];
      if (!cur) top.forEach(function (it) { if (rec && Math.abs(it.price - target) < Math.abs(rec.price - target)) rec = it; });
      var rest = pool.filter(function (it) { return it !== rec; });
      var low = rest.filter(function (it) { return rec && it.price < rec.price; })[0];
      var high = rest.filter(function (it) { return rec && it.price > rec.price; })[0];
      rest = rest.filter(function (it) { return it !== low && it !== high; });
      if (!low) low = rest.shift();
      if (!high) high = rest.shift();
      /* Siempre de menor a mayor precio y la recomendada es la de precio intermedio */
      var trio = [low, rec, high].filter(Boolean).sort(function (a, b) { return a.price - b.price; });
      if (trio.length === 3 && !cur) rec = trio[1];
      var rf = $('[data-r-for]', root), em = document.createElement('em');
      rf.textContent = root.dataset.for + ' '; em.textContent = p.dataset.say; rf.appendChild(em);
      var tag = $('[data-r-tag]', root); tag.textContent = p.dataset.tag ? '«' + p.dataset.tag + '»' : ''; tag.hidden = !p.dataset.tag;
      var box = $('[data-r-trio]', root);
      box.innerHTML = '';
      trio.forEach(function (it, i) { box.appendChild(card(it, it === rec, root, i + 1)); });
      var all = $('[data-r-all]', root);
      if (p.dataset.colUrl) all.href = p.dataset.colUrl;
      if (p.dataset.all) all.firstChild.textContent = p.dataset.all + ' ';
      track('recommender_complete', { recipient: p.dataset.say, grabado: st.grabado || 'any', tipo: st.tipo || 'any', product: rec ? rec.handle : '' });
      go(4);
    }

    people.forEach(function (b) {
      b.addEventListener('click', function () {
        st.person = b; st.grabado = null; st.tipo = null; st.gName = ''; st.tName = ''; st.items = []; st.extra = []; st.extraP = Promise.resolve(); st.textra = []; st.textraP = Promise.resolve();
        people.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        availability(); go(2);
        track('recipient_click', { recipient: b.dataset.say, source: 'recommender' });
        load(b.dataset.col).then(function (items) { if (st.person === b) { st.items = items; availability(); } });
      });
    });
    gs.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.cmhGrabado;
        st.grabado = key; st.gName = b.dataset.name; st.tipo = null; st.tName = ''; st.extra = []; st.textra = []; st.textraP = Promise.resolve();
        st.extraP = load(b.dataset.col).then(function (items) {
          if (st.grabado !== key) return;
          st.extra = items.map(function (it) { var g = Object.assign({}, it.grabado); g[key] = 1; return Object.assign({}, it, { grabado: g }); });
          availability();
        });
        availability(); go(3); track('recommender_grabado', { value: st.grabado });
      });
    });
    ts.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.cmhTipo;
        st.tipo = key; st.tName = b.dataset.name;
        st.textraP = load(b.dataset.col).then(function (items) {
          st.textra = items.map(function (it) { return Object.assign({}, it, { tipo: key }); });
        });
        track('recommender_tipo', { value: st.tipo });
        Promise.all([load(st.person.dataset.col), st.extraP, st.textraP]).then(result);
      });
    });
    $$('[data-skip]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.skip === '2') { st.grabado = null; st.extra = []; st.extraP = Promise.resolve(); st.textra = []; st.textraP = Promise.resolve(); st.gName = b.textContent.trim(); availability(); go(3); }
        else { st.tipo = null; st.tName = b.textContent.trim(); st.textra = []; st.textraP = Promise.resolve(); Promise.all([load(st.person.dataset.col), st.extraP]).then(result); }
      });
    });
    $$('[data-go]', root).forEach(function (b) { b.addEventListener('click', function () { if (+b.dataset.go < st.step) go(+b.dataset.go); }); });
    var rs = $('[data-restart]', root);
    if (rs) rs.addEventListener('click', function () { st.person = null; go(1); });
  }

  function boot() { $$('[data-cmh-rec]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
